<template lang="pug">
  app-modal(
    :titulo="titulo",
    :width=500,
    :hasFooter="false",
    @closeModal="closeModal"
  )
    template.conteudoModal(slot="body")
      el-row(type='flex')
        el-switch(
          v-model="receberNotificacao",
          active-color="#13ce66"
        )
        i(:style="{'margin-left': '5px', 'color': receberNotificacao ? '#009f61' : '#606266'}") Habilitar notificação
      div.containerInputs
        label
          strong Nome:
          el-input.input(v-model="nome", maxlength="100" placeholder="Nome")
        label
          strong Nome do serviço:
          el-input.input(v-model="nomeDoServico", maxlength="100", placeholder="Nome do serviço")
        label
          strong Ip:
          el-input.input(v-model="ip", placeholder="Ip", maxlength="15", show-word-limit)
        label
          strong Porta:
          el-input.input(v-model="porta", maxlength="100", placeholder="Porta", type="number")
      div.containerBotao
        el-button.botaoModal(@click="closeModal") cancelar
        el-button.botaoModal(v-if="!moduloParaEditar", type="primary", @click="adicionar") Cadastrar
        el-button.botaoModal(v-else, type="primary", @click="atualizarModulo") atualizar
</template>
<script>
import AppModal from '@/components/AppModal.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  data () {
    return {
      nome: this.moduloParaEditar ? this.moduloParaEditar.nome : '',
      ip: this.moduloParaEditar ? this.moduloParaEditar.ip : '',
      porta: this.moduloParaEditar ? this.moduloParaEditar.porta : null,
      nomeDoServico: this.moduloParaEditar ? this.moduloParaEditar.nomeDoServico : '',
      titulo: this.moduloParaEditar ? 'Editar Modulo' : 'Adicionar Modulo',
      receberNotificacao: false
    }
  },
  props: {
    moduloParaEditar: {
      type: Object,
      default: null
    }
  },
  components: {
    AppModal
  },
  mixins: [
    AppNotificacao
  ],
  methods: {
    closeModal () {
      this.$emit('closeModal')
    },
    cancelar () {
      this.$emit('closeModal')
    },
    adicionar () {
      const moduloAdd = { nome: this.nome, nomeDoServico: this.nomeDoServico, ip: this.ip, porta: this.porta }
      if (!this.nome || !this.nomeDoServico || !this.ip || !this.porta) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Preencha todos os campos!')
      } else {
        this.$emit('adicionar', moduloAdd)
      }
    },
    atualizarModulo () {
      const modulo = { dadosParaAtualizacao: { nome: this.nome, nomeDoServico: this.nomeDoServico, ip: this.ip, porta: this.porta }, idModulo: this.moduloParaEditar.id }
      if (!this.nome || !this.nomeDoServico || !this.ip || !this.porta) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Preencha todos os campos!')
      } else {
        this.$emit('atualizarModulo', modulo)
      }
    }
  }
}
</script>
<style scoped>
 .conteudoModal{
    padding: 5px;
  }
  .input{
    width: 100%;
    margin-bottom: 15px;
  }
  .containerInputs{
    margin-top: 17px;
    display: flex;
    flex-direction: column;
  }
  .containerBotao{
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  label {
    display: flex;
    width: 100%;
    flex-direction: column;
  }
  .botaoModal {
    width: 130px;
    height: 40px;
  }
  strong {
    font-size: 15px;
    margin-bottom: 3px;
  }
  .notificacao {
    margin-left: 2px;
  }

</style>



// WEBPACK FOOTER //
// src/screens/manutencao/components/modal/AppModalGerenciamentoModulos.vue